<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="predictor-app">
    <!-- <pre>{{isLoading}}</pre> -->
    <explore></explore>
    <guide :data="guide" :key="guide.type"></guide>
    <!-- EXPLORE-CORE -->
    <div class="vx-row">
      <div class="vx-col w-full" v-if="!isLoading">
        <visualizer :artefact="artefact" :key="artefact.query"></visualizer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Explore from "./Explore.vue";
import Guide from "./Guide.vue";
import Visualizer from "./Visualizer.vue";

import { actionsTypes } from "../shared/state";

export default {
  data() {
    return {
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      payload: {
          tags: [],
          dateRange: [],
          query: "",
          mode: "",
          type: "",
          res: {}
        }
    };
  },
  computed: {
    ...mapGetters({guide: "predictor/guide", artefact: "predictor/artefact", isLoading: "predictor/isLoading"})
  },
  methods: {
    init() {
      this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_GUIDE, this.payload);
      this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT, this.payload);
    },
  },
  components: {
    VuePerfectScrollbar,
    Explore,
    Guide,
    Visualizer
  },
  created() {
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
  
};
</script>